import './App.css'
import './index.css'
import ClientDetails from './pages/ClientDetails/ClientDetails'
import { ClientInvestments } from './pages/ClientInvestments/ClientInvestments'
import GoalDetail from './pages/Goals/GoalDetail'
import ClientPdf from './pages/ClientPdf/ClientPdf'
import LoginPage from './pages/Login/LoginPage'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import Layout from "./components/Layout/Layout"
import { DownloadPdf } from './pages/DownloadPdf/DownloadPdf'
import PlanOutput from './pages/PlanOutput/PlanOutput'
import Search from './pages/Search/Search'
import Admin from './pages/Admin/Admin'
import InsuranceLoans from './pages/InsuranceLoans/InsuranceLoans'

function App() {
  
  return (
    <>
    <BrowserRouter>
    <Routes>
      <Route element={<Layout/>}>
        <Route path='/plan-output' element={<PlanOutput/>}/>
        <Route path='/client-details' element={<ClientDetails/>}/>
        <Route path='/client-investments' element={<ClientInvestments/>}/>
        <Route path='/insurance-loans' element={<InsuranceLoans/>}/>
        <Route path='/goal-detail' element={<GoalDetail/>}/>
        <Route path='/search' element={<Search/>}/>
        <Route path='/admin' element={<Admin/>}/>
      </Route>
      <Route path='/' element={<LoginPage/>}/>
      <Route path='/login' element={<LoginPage/>}/>
      <Route path='/client-pdf/:plan_id' element={<ClientPdf/>}/>
      <Route path='/download-pdf' element={<DownloadPdf/>}/>
    </Routes>
    </BrowserRouter>
    
    </>
  )
}

export default App
